import { Button, Icon, Modal } from "semantic-ui-react";

type ModScheduleErrMessageProps = {
  open: boolean;
  subtitle: string;
  title: string;
  onClose: () => void;
};

const IMAGES = {
  error: "/static/images/schedule/calendar-error-icon.png",
  success: "/static/images/schedule/calendar-success-icon.png",
};

const ModScheduleErrMessage = (props: ModScheduleErrMessageProps) => (
  <Modal
    style={{
      border: "1px solid rgba(243, 130, 160, 1)",
      borderRadius: "12px",
    }}
    open={props.open}
    size="tiny"
    closeOnDimmerClick
    onClose={props.onClose}
  >
    <div style={{ padding: "1rem" }}>
      <div style={{ display: "flex", justifyContent: "flex-end", marginBottom: "0.5rem" }}>
        <Icon
          style={{
            color: "rgba(79, 79, 79, 1)",
            fontSize: "1.2rem",
            margin: 0,
          }}
          name="close"
          link
          onClick={props.onClose}
        />
      </div>

      <div style={{ margin: "2.5rem 0 1.5rem", textAlign: "center" }}>
        <img
          style={{ width: "130px" }}
          alt="calendar-error-icon"
          src={props.subtitle ? IMAGES.error : IMAGES.success}
        />
      </div>

      <div style={{ marginBottom: "2rem", textAlign: "center" }}>
        <h3
          style={{
            color: "rgba(243, 130, 160, 1)",
            fontSize: "1.3rem",
            fontWeight: "600",
            marginBottom: "0.75rem",
          }}
        >
          {props.title}
        </h3>
        <p
          style={{
            color: "rgba(79, 79, 79, 1)",
            fontSize: "1.2rem",
            margin: 0,
            whiteSpace: "pre-wrap",
          }}
        >
          {props.subtitle}
        </p>
      </div>

      <div style={{ textAlign: "center" }}>
        <Button
          style={{
            backgroundColor: "rgba(200, 200, 200, 1)",
            borderRadius: "6px",
            fontSize: "1rem",
            marginBottom: "1rem",
          }}
          onClick={props.onClose}
        >
          ปิดหน้าต่าง
        </Button>
      </div>
    </div>
  </Modal>
);

export default ModScheduleErrMessage;
